import { useReducer, Dispatch, Reducer } from 'react';

import produce, { Draft } from 'immer';

import { Action, STEP } from './constants';
import { StateType, ActionType } from './types';

export const initialState: StateType = {
  step: STEP.CREATING_ACCOUNT,
  account: undefined,
};

const reducer: Reducer<StateType, ActionType> = produce(
  (draft: Draft<StateType>, action: ActionType) => {
    const { type } = action;
    switch (type) {
      case Action.SET_STEP: {
        if (action.account) {
          draft.account = action.account;
        }
        draft.step += 1;
        break;
      }
      default:
        throw new Error();
    }
  },
  initialState
);

export const useCreateAccountReducer = (): [StateType, Dispatch<ActionType>] =>
  useReducer(reducer, initialState);

export default reducer;
